import type { Nullable } from "@core/domain/types/nullable.type";
import type { Undefinable } from "@core/domain/types/undefinable.type";
import * as z from "zod";

const PlotStationDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim(),
        code: z.string().trim(),
    })
    .readonly();

export const PlotDtoSchema = z
    .object({
        id: z.number(),
        name: z.string().trim().nullable(),
        document_url: z.string().trim().nullable(),
        geo_json: z.string().trim(),
        clay_percentage: z.number().nullable(),
        silt_percentage: z.number().nullable(),
        sand_percentage: z.number().nullable(),
        stations: z.array(PlotStationDtoSchema),
    })
    .readonly();
export type PlotDto = z.output<typeof PlotDtoSchema>;

export interface PlotCreateBody {
    parcel: {
        geo_json: string;
    };
}
export interface PlotUpdateBody {
    parcel: {
        name: Nullable<string>;
        station_ids: number[];
        clay_percentage: Nullable<number>;
        silt_percentage: Nullable<number>;
        sand_percentage: Nullable<number>;
    };
}

export interface PlotFileBodyContent {
    document: Undefinable<File>;
}
export type PlotFileBody = FormData;

export const PlotFileDtoSchema = z.object({
    document_url: z.string().trim(),
});
export type PlotFileDto = z.output<typeof PlotFileDtoSchema>;
